var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import store from "@/app/store/store";
import { GetUserViewPaginatedQuery, GetUsersContactsCSVReportQuery, PaginatedEnumerableOfUserQuery, SortDescription, SortDirection, UsersClient, RolesClient, CompaniesClient, SitesClient, GetCompanyListQuery, GetSiteListQuery } from "@/app/api/battery-portal-api";
import RouteNames from "@/app/router/routes";
import { LoginState } from "@/app/store/modules/login.state";
import { DateHelper } from "@/app/utils/date-helper";
import { HttpHelper } from "@/app/utils/http-helper";
import TimerVue from "@/app/vues/components/timer.vue";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { Component, Vue, Watch, Ref } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { DataGridStateHelper } from "@/app/utils/data-grid-state-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import LockUnlockUsersModal from "@/app/vues/components/lock-unlock-users-modal.vue";
import moment from "moment";
const usersClient = new UsersClient(window.apiUrl);
const roleClient = new RolesClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let UsersVue = class UsersVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.searchAttempted = false;
        this.showExportUsersModal = false;
        this.showLockUnlockModal = false;
        // arrays
        this.roles = [];
        this.companies = [];
        this.sites = [];
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "UserName",
            direction: SortDirection.Ascending
        }));
        this.query = new GetUserViewPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfUserQuery();
        this.columns = [
            { visible: true, fieldName: "userName", title: "Username" },
            { visible: true, fieldName: "firstName", title: "First Name" },
            { visible: true, fieldName: "lastName", title: "Last Name" },
            { visible: false, fieldName: "companies", title: "Company Name" },
            { visible: true, fieldName: "sites", title: "Site Name" },
            { visible: true, fieldName: "emailAddress", title: "Email" },
            { visible: true, fieldName: "roleName", title: "Role" },
            { visible: true, fieldName: "lastLogin", title: "Last Login" },
            { visible: false, fieldName: "lastSeen", title: "Last Seen" },
        ];
        this.exportQuery = new GetUsersContactsCSVReportQuery({
            exportContacts: true,
            exportUsers: true,
            timezoneOffset: moment().utcOffset(),
        });
    }
    created() {
        this.loadDataGridState();
        this.getLookups();
        this.search();
    }
    ;
    // get
    search() {
        if (this.working)
            return;
        this.working = true;
        console.log('query', this.query);
        usersClient
            .search(this.query)
            .then(response => {
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    getLookups() {
        let promises = [
            roleClient
                .getList(true)
                .then(response => {
                var roles = (response || []).map((item) => {
                    return {
                        value: item.roleId,
                        text: item.roleName
                    };
                });
                this.roles = [{ value: null, text: `All roles` }].concat(roles);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            companyClient
                .getListPOST(new GetCompanyListQuery({
                includeDeleted: false,
                keywords: null
            }))
                .then(response => {
                var companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            siteClient
                .getListPOST(new GetSiteListQuery({
                includeDeleted: false,
                keywords: null,
                companyId: null
            }))
                .then(response => {
                this.sites = response;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
        ];
        Promise.all(promises);
    }
    ;
    onDataGridStateChanged() {
        DataGridStateHelper.storeDataGridState("user-grid", this.columns, this.sorter, this.query.includeDeleted);
    }
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        if (!this.working) {
            this.onDataGridStateChanged();
            this.search();
        }
    }
    ;
    // set
    edit(user) {
        this.$router.push({ name: RouteNames.User, params: { id: user.userId.toString() } });
    }
    ;
    archive(user) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this user?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            usersClient
                .delete(user.userId)
                .then(() => {
                user.whenDeleted = new Date();
                Notifier.onOk(`User # ${user.userId} has been successfully archived.`);
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(user) {
        if (this.working)
            return;
        this.working = true;
        usersClient
            .restore(user.userId)
            .then(() => {
            user.whenDeleted = undefined;
            Notifier.onOk(`User # ${user.userId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    unlock(user) {
        if (this.working)
            return;
        this.working = true;
        usersClient
            .unlock(user.userId)
            .then(() => {
            user.whenLockoutEnds = undefined;
            Notifier.onOk(`User # ${user.userId} has been successfully unlocked.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    whenLastLoggedInString(user) {
        return DateHelper.convertToFriendlyMomentTimeString(user.whenLastLoggedIn || null);
    }
    ;
    // An account that has never signed in reads as "Never" rather than as a blank cell, because a
    // blank cell is indistinguishable from a column that failed to load - and "never used" is the
    // single most interesting answer when reviewing accounts for deprovisioning.
    whenLastSeenString(user) {
        return user.whenLastSeen ? DateHelper.convertToRelativeTimeString(user.whenLastSeen) : "Never";
    }
    ;
    // The column is only accurate to the minute, so the tooltip carries the stored value rather
    // than implying a precision the number does not have.
    whenLastSeenExactString(user) {
        return user.whenLastSeen ? DateHelper.convertToFriendlyMomentTimeString(user.whenLastSeen) : "";
    }
    ;
    get role() {
        return this.roles.filter(item => {
            return (item.value == this.query.roleId);
        })[0] || null;
    }
    ;
    set role(item) {
        if (!item)
            return;
        this.query.roleId = item.value;
    }
    ;
    get company() {
        return this.companies.filter(item => {
            return (item.value == this.query.companyId);
        })[0] || null;
    }
    ;
    set company(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get site() {
        return this.filteredSites.filter(item => {
            return (item.value == this.query.siteId);
        })[0] || null;
    }
    ;
    set site(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
    get filteredSites() {
        return [
            { value: null, text: 'All sites' },
            ...this.sites
                .filter(site => { var _a; return !((_a = this.query) === null || _a === void 0 ? void 0 : _a.companyId) || site.companyId == this.query.companyId; })
                .map(site => ({
                value: site.siteId,
                text: site.siteName
            }))
        ];
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    get isPowerShield() {
        return this.loginState.isPowerShield;
    }
    ;
    get isPowerShieldAdministrator() {
        return this.loginState.isPowerShieldAdministrator;
    }
    ;
    closeColumnSettingsMenu() {
        let dropdown = this.$refs.columnSettingsDropdown;
        dropdown.close(true);
    }
    ;
    get numberOfVisibleColumns() {
        return this.columns.filter(column => column.visible).length;
    }
    ;
    get isThirdPartyAuth() {
        return store.getters["appConfigModule/isThirdPartyAuth"];
    }
    isVisible(name) {
        let column = this.columns.filter(column => {
            return column.fieldName.toLowerCase() == name.toLowerCase();
        })[0];
        return column ? column.visible : false;
    }
    ;
    loadDataGridState() {
        this.working = true;
        try {
            var state = DataGridStateHelper.loadDataGridState("user-grid", this.columns, this.sorter);
            if (state != null) {
                this.query.includeDeleted = state.includeDeleted;
            }
        }
        finally {
            this.working = false;
        }
    }
    exportToPdf() {
        if (this.working)
            return;
        this.working = true;
        usersClient.downloadUsersContactsAsCsv(this.exportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], UsersVue.prototype, "loginState", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], UsersVue.prototype, "lockUnlokUsersModal", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.companyId"),
    Watch("query.siteId"),
    Watch("query.roleId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UsersVue.prototype, "search", null);
__decorate([
    Watch("query.includeDeleted"),
    Watch("numberOfVisibleColumns"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UsersVue.prototype, "onDataGridStateChanged", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], UsersVue.prototype, "onSortChanged", null);
UsersVue = __decorate([
    Component({
        name: "UsersVue",
        components: {
            TimerVue,
            LockUnlockUsersModal
        }
    })
], UsersVue);
export default UsersVue;
